export type LookInsidePage = {
  src: string
  caption: string
}

export const lookInsidePages: LookInsidePage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/egGCRfiLiJHmPrEgdaELNQ/01_vol2-pagina-1.webp',
    caption: 'The cover: Volume 2, Strength & Holds',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/tmZF39rj6hmbP8dXPcnNa3/02_vol2-pagina-5.webp',
    caption: 'The hold ladder, on one page',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/aghwbxdwBSYMgpkbjAYeFk/03_vol2-pagina-7.webp',
    caption: 'A full class in 30, 45 and 55 minutes',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/23aiLJnKUcRCsdPDa7QVFY/04_vol2-pagina-16.webp',
    caption: 'Every block, counted and cued',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/dQ9mcpXcdHWaBDXnfjAE1a/05_vol2-pagina-50.webp',
    caption: 'The whole volume on one card',
  },
]
